//#region types
import { FormEnums } from "models/enums";
import { AutomationRuleFormTypes } from "models/formTypes";
import { GenericFormSection } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModelCustomerAutomationsCommon as Common } from "wint-api-client/dist/types";
import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import { FilterQueryStateHandler } from "models/propTypes/filterPropTypes";
//#endregion
import useAvailableRuleTypesList from "./useAvailableRuleTypesList";
//#region components
//#endregion
import { FilterHelper, QueryStateHelper } from "utils/helpers";

function useAutomaticRuleFilterDefinition() {
  const { availableRuleTypes } = useAvailableRuleTypesList();
  const apiToReportFilterFormatter = async (
    filter: Common.AutomationRuleFilter
  ): Promise<AutomationRuleFormTypes.Filter> => {
    const reportFilter: AutomationRuleFormTypes.Filter = {};

    if (filter.active !== undefined) {
      reportFilter.active = filter.active;
    }

    if (filter.ruleSubTypes !== undefined) {
      reportFilter.type = availableRuleTypes.filter((t) => filter.ruleSubTypes?.includes(t.id as number));
    }

    FilterHelper.setDateRange(
      reportFilter,
      FormFieldConstants.AutomationRule.Filter.CreatedDate,
      filter.createdFromDate,
      filter.createdToDate
    );

    FilterHelper.setNumberRange(
      reportFilter,
      FormFieldConstants.AutomationRule.Filter.TotalProcessedEvents,
      filter.minTotalProcessedEvents,
      filter.maxTotalProcessedEvents
    );

    return reportFilter;
  };

  const filterFormFields: GenericFormSection<AutomationRuleFormTypes.Filter>[] = [
    {
      label: TranslationKeys.Common.General,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: {
        type: {
          label: TranslationKeys.Common.Type,
          type: FormEnums.FormFieldType.MULTIPLESELECTION,
          extraProps: {
            items: availableRuleTypes as AutocompleteListItem[],
          },
        },
        totalProcessedEvents: {
          label: TranslationKeys.AutomationRule.AutomatedEvents,
          type: FormEnums.FormFieldType.NUMBERRANGE,
        },
        createdDate: {
          label: TranslationKeys.AutomationRule.CreateDate,
          type: FormEnums.FormFieldType.DATERANGE,
        },
        active: {
          label: TranslationKeys.Common.Active,
          type: FormEnums.FormFieldType.BOOLEANSELECTION,
        },
      },
    },
  ];

  const filterQueryStateHandler: FilterQueryStateHandler<AutomationRuleFormTypes.Filter> = {
    active: QueryStateHelper.booleanQueryEncoder(FormFieldConstants.AutomationRule.Filter.Active),
    totalProcessedEvents: QueryStateHelper.numberRangeQueryEncoder(
      FormFieldConstants.AutomationRule.Filter.TotalProcessedEvents
    ),
    createdDate: QueryStateHelper.dateRangeQueryEncoder(FormFieldConstants.AutomationRule.Filter.CreatedDate),
    type: QueryStateHelper.selectionItemsQueryEncoder(
      FormFieldConstants.AutomationRule.Filter.Type,
      availableRuleTypes
    ),
  };

  return { filterFormFields, filterQueryStateHandler, apiToReportFilterFormatter };
}

export default useAutomaticRuleFilterDefinition;
